module.exports = {
          srcSet: __webpack_public_path__ + "f5e8afae.jpg"+" 45w",
          images:[ {path: __webpack_public_path__ + "f5e8afae.jpg",width: 45,height: 45}],
          src: __webpack_public_path__ + "f5e8afae.jpg",
          toString:function(){return __webpack_public_path__ + "f5e8afae.jpg"},
          
          width: 45,
          height: 45
        }